import styled from "styled-components";

export const Container = styled.div`
text-align: center;
`
export const NFSpan = styled.span`
  font-size: 64px;
`;